let desktop_data_bubbles = document.querySelectorAll(
  ".desktop_data_bubbles .content_heading h4 .count"
);
let mobile_data_bubbles = document.querySelectorAll(
  ".mobile_data_bubbles .content_heading h4 .count"
);

let SHEET_ID = "1EsMDjtm9qV3sJiJbUyAey2J46XuBHUn-XOPi9Hnu734";
let SHEET_TITLE = "Impact calculator";
let SHEET_RANGE = "D2,D4,D6";

let FULL_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?sheet=${SHEET_TITLE}&range=${SHEET_RANGE}`;

fetch(FULL_URL)
  .then((res) => res.text())
  .then((data) => {
    const temp = data.substr(47).slice(0, -2);
    const json = JSON.parse(temp);
    const rows = json.table.rows;
    const row_cells = rows[rows.length - 1].c;

    // MODIFY THIS CODE TO LOOP THROUGH THE DATA AND UPDATE THE BUBBLE DATA
    function formattedNumber(number){
      let formattedNumber = number.toLocaleString('en-US', {maximumFractionDigits: 0}).replace(/,/g, '.');
      return formattedNumber;
    }

    row_cells.forEach((cell, index) => {
      let number = parseInt(cell.f);
      number = formattedNumber(number);

      desktop_data_bubbles[index].innerHTML = number;
      mobile_data_bubbles[index].innerHTML = number;
    });
  });

document.addEventListener(
  "DOMContentLoaded",
  function () {
    let fadeComplete = function (e) {
      stage.appendChild(arr[0]);
    };
    let stage = document.getElementById("animation-wrapper");
    let arr = stage.getElementsByTagName("animated-bubble");

    for (let i = 0; i < arr.length; i++) {
      arr[i].addEventListener("animationend", fadeComplete, false);
    }
  },
  false
);

function handleWindowEvent() {
  inViewport();
  handleCounter();
}

window.addEventListener('scroll', handleWindowEvent);
window.addEventListener('resize', handleWindowEvent);

let countDone = false;
inViewport();
handleCounter();

function inViewport() {
  document.querySelectorAll(".data_bubbles").forEach(function(el) {
    const divPos = el.getBoundingClientRect().top + window.scrollY;
    const topOfWindow = window.scrollY;

    if (divPos < topOfWindow + 700) {
      el.classList.add("data_bubbles_start");
    }
  });

  document.querySelectorAll(".animation_content_wrapper").forEach(function(el) {
    const divPos = el.getBoundingClientRect().top + window.scrollY;
    const topOfWindow = window.scrollY;

    if (divPos < topOfWindow + 700) {
      el.classList.add("animation_content_wrapper_start");
    }
  });

  document.querySelectorAll(".counter_number").forEach(function(el) {
    const divPos = el.getBoundingClientRect().top + window.scrollY;
    const topOfWindow = window.scrollY;

    if (divPos < topOfWindow + 700) {
      el.classList.add("num");
    }
  });
}


function handleCounter() {
  // ------------- COUNTER ----------------------
  const counters = document.querySelectorAll(".num");
  let divPos = $(".counter_number").offset().top,
    topOfWindow = $(window).scrollTop();
  if (!countDone) {
    if (divPos < topOfWindow + 700) {
      counters.forEach((counter, index) => {
        counter.innerText = "1000";
        const updateCounter = () => {
          if (window.plasticBottleCount) {
            var count = window.plasticBottleCount;
          } else {
            var count = counter.getAttribute("data-val");
          }
          const target = +count;
          const c = +counter.innerText;
          const increment = target / 450;
          if (c < target) {
            counter.innerText = `${Math.ceil(c + increment)}`;
            setTimeout(updateCounter, 1);
          } else {
            counter.innerText = target;
          }
        };
        updateCounter();
        countDone = true;
      });
    }
  }
}
